import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
//自定义主题样式 
import './assets/css/theme/index.css';
Vue.use(ElementUI, {size: "small"});

import plugin from './plugin'
import * as filters from './plugin/filters'
Vue.use(plugin, { someOption: true })
// register filter
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// import './permission'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
